import React from "react";
import { InputNumber } from "rsuite";

interface Props {
  placeholder: string;
  max?: number;
  min: number;
  defaultValue?: number;
  style?: { width: number };
  onChange?: any;
  isValidate?: boolean;
  value?: any;
  allowPrecision?: boolean;
  hasError?: boolean;
  step?: number;
}

const handleKeyPress = (e: any) => {
  const pattern = /[0-9]/;
  const inputChar = String.fromCharCode(e.which);
  if (!pattern.test(inputChar) && e.key !== "Enter") {
    e.preventDefault();
  }
};

export const EPInputNumber: React.FC<Props> = ({
  placeholder,
  isValidate,
  value,
  max,
  step,
  min,
  defaultValue,
  style = {},
  onChange,
  allowPrecision,
  hasError,
}) => {
  return (
    <div
      className={
        (value !== 0 && !value && isValidate) || hasError
          ? "border border-danger"
          : ""
      }
    >
      <InputNumber
        value={value}
        placeholder={placeholder}
        max={max}
        min={min}
        step={step || 1}
        defaultValue={defaultValue}
        style={style}
        onChange={(value: any) => {
          onChange(value);
        }}
        onKeyPress={!allowPrecision ? handleKeyPress : () => {}}
      />
    </div>
  );
};
